export default __webpack_public_path__ + "static/media/it-62.e1bee05f.svg";